import React from 'react';
import cx from 'classnames';

import AssetStats, { AssetStatsProps } from './AssetStats';

export interface AssetDetailsProps extends AssetStatsProps {
  name: string;
  redirectUrl?: string;
  actionLinksComponent?: React.ReactNode;
  className?: string;
}

export default function AssetDetails({
  name,
  redirectUrl,
  actionLinksComponent,
  children,
  className,
}: AssetDetailsProps) {
  return (
    <div className={cx('w-full mt-2.5', className)}>
      <div className='flex justify-between align-items'>
        <a
          className='max-w-[272px] font-normal text-base text-black text-truncate overflow-ellipsis overflow-hidden'
          href={redirectUrl}
        >
          {name}
        </a>
        {actionLinksComponent}
      </div>
      <div className='inline-flex items-center flex-wrap mb-2.5 w-full'>
        <AssetStats>{children}</AssetStats>
      </div>
    </div>
  );
}
